import { cloneDeep } from 'lodash'

export const defaultDashboardData = {
  available_utilities: [],
  building_usage: {},
  building_totals: {},
  month_array: [],
  ghg_breakdown: {},
};

export const defaultDashboardInfo = {
  building_info: {},
  benchmark_missing: [],
  benchmark_data: {},
  benchmark_survey: null,
};

export const dashboardMerge = (dashboardData, newData) => {
  if (Object.keys(dashboardData).length === 0) {
    return newData
  }
  if (Object.keys(newData).length === 0) {
    return { ...dashboardData }
  }
  // available utilities
  newData['available_utilities'].forEach((util) => {
    if (!dashboardData['available_utilities'].includes(util)) {
      dashboardData['available_utilities'].push(util)
    }
  })

  // buildinng totals
  Object.keys(newData['building_totals']).forEach((bid) => {
    dashboardData['building_totals'][bid] = newData['building_totals'][bid]
  })
  // building usage
  Object.keys(newData['building_usage']).forEach((bid) => {
    dashboardData['building_usage'][bid] = newData['building_usage'][bid]
  })
  //ghg_breakdown
  Object.keys(newData['ghg_breakdown']).forEach((bid) => {
    dashboardData['ghg_breakdown'][bid] = newData['ghg_breakdown'][bid]
  })

  // month_array
  dashboardData['month_array'] = newData['month_array']

  return { ...dashboardData }

}

export const dashboardRotate = (dashboardData, d1, d2) => {
  if (Object.keys(dashboardData).length > 0) {
    let new_dashboard_data = cloneDeep(dashboardData)

    const month_lookup = createMonthLookup(d1)
    const baseline_months = createBaselineMonths(d2)


    // building_usage
    Object.keys(dashboardData['building_usage']).forEach((building) => {
      Object.keys(dashboardData['building_usage'][building]).forEach((utility) => {

        new_dashboard_data['building_usage'][building][utility] = rotateReportTypes(dashboardData['building_usage'][building][utility], month_lookup, baseline_months)

      })

      // ghg_breakdown
      Object.keys(new_dashboard_data['ghg_breakdown']).forEach((key) => {
        new_dashboard_data['ghg_breakdown'][key]['monthly'] = adjustArray(dashboardData['ghg_breakdown'][key]['monthly'], month_lookup, baseline_months)
      })


      // month_array
      new_dashboard_data['month_array'] = adjustArray(dashboardData['month_array'], month_lookup, baseline_months)

    })
    return new_dashboard_data;
  }
  else {
    return dashboardData
  }
}

const special_arrays = ['consumptions', 'costs', 'sub_usages', 'sub_costs'];

const rotateReportTypes = (dashboardReportArrays, month_lookup, baseline_months) => {
  let new_reports_arrays = {}
  Object.keys(dashboardReportArrays).forEach((r_type) => {
    if (special_arrays.includes(r_type)) {
      new_reports_arrays[r_type] = {}
      Object.keys(dashboardReportArrays[r_type]).forEach((sub_r_type) => {
        new_reports_arrays[r_type][sub_r_type] = adjustArray(dashboardReportArrays[r_type][sub_r_type], month_lookup, baseline_months)
      })
    }
    else {
      new_reports_arrays[r_type] = adjustArray(dashboardReportArrays[r_type], month_lookup, baseline_months)
    }
  })
  return new_reports_arrays
}

const adjustArray = (arr, month_lookup, baseline_months) => {
  let new_arr = [null, null, null, null, null, null, null, null, null, null, null, null]


  arr.forEach((el, idx) => {
    new_arr[month_lookup[baseline_months[idx]]] = el
  })
  return new_arr
}

const createMonthLookup = (d1) => {
  let month_lookup = [null, null, null, null, null, null, null, null, null, null, null, null]

  let cur_month = d1.month()
  let local_month = cur_month
  for (let i = 0; i < 12; i++) {
    local_month = cur_month % 12
    month_lookup[local_month] = i
    cur_month += 1
  }
  return month_lookup
}


const createBaselineMonths = (d2) => {
  let baseline_months = []

  let cur_month = d2.month()
  let local_month = cur_month
  for (let i = 0; i < 12; i++) {
    local_month = cur_month % 12
    baseline_months.push(local_month)
    cur_month += 1
  }

  return baseline_months
}